<template>
  <time-table v-if="timetableLoaded"/>
</template>

<script>
import TimeTable from '@/components/TimeTable';
import { mapState } from 'vuex';
import LoadingState from '@/api/LoadingState';

export default {
  name: 'TimeTablePage',
  components: { TimeTable },
  computed: {
    ...mapState({
      timetableLoaded: (state) => state.run.loadingState.timetable === LoadingState.LOADED
    })
  }
}
</script>

<style scoped>

</style>
